import { createFileRoute } from '@tanstack/react-router';

import { TravelApprovalBrowse } from '@/module/Travel/Approval/TravelApprovalBrowse';

export const Route = createFileRoute('/_auth/travel/_travel/approvals/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelApprovalBrowse />;
}
